import request from '../utils/request'

/* 获取所有模块配置数据 */
export const getAllCfgModuleApi = () => {
  return request({
    url: '/front/index/getAllCfgModule',
    params: {
      productCode: 'RDPI'
    }
  })
}
// 聚类
export const elasticAggApi = (data) => {
  return request({
    url: '/elastic/agg',
    method: 'post',
    data
  })
}

// 分页查询
export const elasticPageApi = (data) => {
  return request({
    url: '/elastic/page',
    method: 'post',
    data
  })
}

// 检索总结
export const retrievalSummary = (params) => {
  return request({
    url: '/elastic/retrievalSummary',
    method: 'GET',
    params
  })
}
 
// 武器类型
export const weapontypeApi = (params) => {
  return request({
    url: '/front/platform/tool/weapontype',
    params
  })
}